import { render } from "./ToznyLoader.vue?vue&type=template&id=16047552"
import script from "./ToznyLoader.vue?vue&type=script&lang=js"
export * from "./ToznyLoader.vue?vue&type=script&lang=js"

import "./ToznyLoader.vue?vue&type=style&index=0&id=16047552&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__